var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MenuSousMenu',{attrs:{"id":"menu_exports","settings":_vm.menu_telecharger,"droite":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }